<form [formGroup]="formGroup">
  <div formArrayName="items">
    <div
      fxLayout="row"
      fxLayoutAlign="start start"
      fxLayoutGap="10px"
      *ngFor="let group of items.controls; let i = index" [formGroupName]="i"
    >
      <mat-form-field fxFlex>
        <mat-label>CPT Code</mat-label>
        <input matInput formControlName="code" placeholder="CPT Code">
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>Status</mat-label>
        <mat-select formControlName="statusCode">
          <mat-option *ngFor="let item of authorizationProcedureStatuses" [value]="item.value">
            {{ item.viewValue | translate }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="!group.value.statusCode" class="text-muted">
          {{ 'dialog.authorization.procedures.status-missing' | translate }}
        </mat-hint>
      </mat-form-field>

      <div fxFlex fxLayout="column" fxLayoutGap="0px">
        <mat-form-field>
          <mat-label>Quantity</mat-label>
          <input
            matInput
            formControlName="quantity"
            type="number"
          >
        <mat-hint *ngIf="group.value.quantity == null && !group.value.quantityNotApplicable" class="text-muted">
          {{ 'dialog.authorization.procedures.quantity-missing' | translate }}
        </mat-hint>
        </mat-form-field>
        <mat-checkbox formControlName="quantityNotApplicable" class="quantity-not-applicable" [ngClass]="{shortened: group.value.quantity !== null}">
          {{ 'dialog.authorization.procedures.quantity-not-applicable' | translate }}
        </mat-checkbox>
      </div>

      <div fxFlex="nogrow">
        <ng-container *ngIf="getRawData(i) as rawData">
          <button
            mat-icon-button
            type="button"
            (click)="viewRawData({ data: rawData, index: i })"
            [matTooltip]="'View Raw Data' | translate"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </ng-container>

        <button
          *ngIf="preventAuthManualOverride && manuallyEditedFields?.has('proceduresData') && getCode(i) && !lockingField"
          mat-icon-button
          type="button"
          class="lock-btn"
          [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate"
          (click)="unlockField.emit('proceduresData')"
        >
          <mat-icon>lock</mat-icon>
        </button>

        <button
          *ngIf="preventAuthManualOverride && !manuallyEditedFields?.has('proceduresData') && getCode(i) && !lockingField"
          mat-icon-button
          type="button"
          class="lock-btn text-muted"
          [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate"
          (click)="lockField.emit()"
        >
          <mat-icon>lock_open</mat-icon>
        </button>

        <button
          *ngIf="lockingField && getCode(i)"
          mat-icon-button
          type="button"
          disabled
        >
          <mat-spinner diameter="20"></mat-spinner>
        </button>

        <button
          mat-icon-button
          type="button"
          mmxConfirmClick
          message="Are you sure you want to remove this code?"
          (confirm)="removeItem(i)"
          class="mt-1 text-warn"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="items.length === 0" fxLayoutAlign="center center" class="p-5">
      {{ emptyMessage | translate }}
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="mb-4">
      <button mat-raised-button type="button" (click)="addItem()">
        <mat-icon>add</mat-icon>
        Add Procedure
      </button>

      <button
        *ngIf="missingCodes.length"
        mat-raised-button
        type="button"
        (click)="addMissingCodes()"
        [matTooltip]="'dialog.authorization.procedures.add-missing-tooltip' | translate: { codes: missingCodes.join(', ') }"
      >
        <mat-icon>playlist_add</mat-icon>
        {{ 'dialog.authorization.procedures.add-missing' | translate }}
      </button>
    </div>
  </div>
</form>
